// state
export const state = {
  status: false,
};

// mutations
export const mutations = {
  SET_SOUND: (state, data) => {
    state.status = data;
  },
};

// actions
export const actions = {
  setSound({ commit }, payload) {
    commit("SET_SOUND", payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
